import { render, staticRenderFns } from "./kyzl.vue?vue&type=template&id=071e9d8e&scoped=true"
import script from "./kyzl.vue?vue&type=script&lang=js"
export * from "./kyzl.vue?vue&type=script&lang=js"
import style0 from "./kyzl.vue?vue&type=style&index=0&id=071e9d8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071e9d8e",
  null
  
)

export default component.exports